import React from 'react';
import { bool, func, string } from 'prop-types';

import MessageThreadButton from '../MessageThreadButton';

import cx from 'classnames';
import s from './NewMsgButton.css';


// Compose New Message is strategized - POR-560
const newMsgButton = ({ messageComposeEnabled, className, handleNewMsgFormDisplay }) => {
  if (messageComposeEnabled) {
    return (
      <nav className={cx(s.component, className)}>
        <MessageThreadButton
          name="New"
          className={s.button}
          handleNewMsgFormDisplay={handleNewMsgFormDisplay}
        />
      </nav>
    );
  } else {
    return null;
  }
};

// Always validate your props and the type
newMsgButton.propTypes = {
  messageComposeEnabled: bool,
  className: string,
  handleNewMsgFormDisplay: func,
};

export default newMsgButton;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/NewMsgButton/NewMsgButton.js